import { useRef, useState } from "react";
import { SketchPicker } from "react-color";

// Radar's color swatch + SketchPicker popover, extracted verbatim from index.tsx.
// NOTE: this is the Radar-local variant (fixed-positioned popover); deduping it
// against shared/ColorSwatchPicker is a deliberate separate change.

const PRESET_COLORS = [
  { color: "#d9534f", title: "Red" },
  { color: "#EF7617", title: "Orange" },
  { color: "#FFC83D", title: "Yellow" },
  { color: "#31B452", title: "Green" },
  { color: "#0000FF", title: "Blue" },
  { color: "#000000", title: "Black" },
  { color: "#cccccc", title: "Grey" },
  { color: "#4d7cf7", title: "Blue (default)" },
  { color: "#f7874d", title: "Orange (default)" },
  { color: "#4df7a8", title: "Green (default)" },
];

function computePickerPos(el: HTMLElement | null): { top?: number; bottom?: number; left: number } {
  if (!el) return { top: 0, left: 0 };
  const r = el.getBoundingClientRect();
  const pickerH = 310;
  return r.bottom + 8 + pickerH < window.innerHeight
    ? { top: r.bottom + 8, left: r.left }
    : { bottom: window.innerHeight - r.top + 8, left: r.left };
}

export function ColorSwatchPicker({
  color,
  onChange,
}: {
  color: string;
  onChange: (hex: string) => void;
}) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      <div
        ref={ref}
        onClick={() => setOpen(!open)}
        style={{
          width: 22,
          height: 22,
          borderRadius: 4,
          border: "1px solid #d9d9d9",
          background: color,
          cursor: "pointer",
          flexShrink: 0,
        }}
      />
      {open && (
        <div
          style={{
            position: "fixed",
            zIndex: 1050,
            ...computePickerPos(ref.current),
          }}
        >
          <div
            style={{ position: "fixed", inset: 0, zIndex: -1 }}
            onClick={() => setOpen(false)}
          />
          <SketchPicker
            color={color}
            disableAlpha
            presetColors={PRESET_COLORS}
            onChange={(c: { hex: string }) => onChange(c.hex)}
          />
        </div>
      )}
    </div>
  );
}
